module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport",
      value: ({}),
      expression: "{}"
    }],
    staticClass: "in-viewport",
    class: {
      navOpen: _vm.navigationToggle,
        open_submenu:
        _vm.normalizedRoutePathLower.includes('/solutions') ||
        // $route.path.includes('/markets') ||
        _vm.normalizedRoutePathLower.includes('/agency') ||
        _vm.normalizedRoutePathLower.includes('/inclusion'),
    },
    attrs: {
      "id": "mt-header"
    }
  }, [_c('div', {
    staticClass: "inside"
  }, [_c('a', {
    attrs: {
      "href": "/",
      "id": "mt-logo-container"
    }
  }, [_c('img', {
    staticClass: "mt-logo",
    attrs: {
      "src": _vm.setLogoUrl(),
      "alt": "Marcus Thomas LLC Logotype"
    }
  })]), _vm._v(" "), (false) ? [(_vm.normalizedRoutePathLower == '/cx2') ? _c('div', {
    staticClass: "cx-2-header"
  }, [_c('a', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport",
      value: ({}),
      expression: "{}"
    }, {
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#contact-form'),
      expression: "'#contact-form'"
    }],
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Contact us")]), _vm._v(" "), _c('span', {
    staticClass: "divider"
  }, [_vm._v("|")]), _vm._v(" "), _c('span', [_vm._v("216.285.2849")])]) : _vm._e(), _vm._v(" "), (_vm.normalizedRoutePathLower != '/cx2') ? _c('div', {
    staticClass: "icon-menu",
    class: {
      scrollDown: _vm.scrollDown
    },
    on: {
      "click": function($event) {
        return _vm.openNavigation()
      }
    }
  }, [_c('span', {
    staticClass: "icon-menu-hamburger"
  })]) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "full-navigation"
  }, [_c('ul', {
    staticClass: "menu"
  }, [_c('li', {
    class: ['hide-desktop', {
      fadeInDown: _vm.navigationToggle
    }]
  }, [_c('router-link', {
    staticClass: "home",
    attrs: {
      "to": '/'
    },
    on: {
      "click": function($event) {
        return _vm.openNavigation()
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', {
    class: {
      fadeInDown: _vm.navigationToggle
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/work'
    },
    on: {
      "click": function($event) {
        return _vm.openNavigation()
      }
    }
  }, [_vm._v("Work")])], 1), _vm._v(" "), _c('li', {
    class: {
      fadeInDown: _vm.navigationToggle
    }
  }, [_c('a', {
    class: _vm.$route.path.includes('/solutions') ?
      'submenu router-link-active' :
      'submenu',
    attrs: {
      "id": "sub_solutions",
      "href": "/solutions",
      "title": "Solutions"
    },
    on: {
      "click": function($event) {
        return _vm.openNavigation()
      }
    }
  }, [_vm._v("Solutions")]), _vm._v(" "), _c('sub-menu', {
    attrs: {
      "moreList": _vm.solutions,
      "baseUrl": '/solutions',
      "isSticky": true
    }
  })], 1), _vm._v(" "), _c('li', {
    class: {
      fadeInDown: _vm.navigationToggle
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/words'
    },
    on: {
      "click": function($event) {
        return _vm.openNavigation()
      }
    }
  }, [_vm._v("Insights")])], 1), _vm._v(" "), _c('li', {
    class: {
      fadeInDown: _vm.navigationToggle
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/agency'
    },
    on: {
      "click": function($event) {
        return _vm.openNavigation()
      }
    }
  }, [_vm._v("Agency")])], 1), _vm._v(" "), _c('li', {
    class: {
      fadeInDown: _vm.navigationToggle
    }
  }, [_c('router-link', {
    class: _vm.$route.path.includes('/inclusion') ?
      'router-link-active' :
      '',
    attrs: {
      "to": '/inclusion',
      "id": "sub_inclusion",
      "title": "Inclusion"
    },
    on: {
      "click": function($event) {
        return _vm.openNavigation()
      }
    }
  }, [_vm._v("Inclusion")])], 1), _vm._v(" "), _c('li', {
    class: {
      fadeInDown: _vm.navigationToggle
    }
  }, [_c('a', {
    class: _vm.$route.path.includes('/careers') ||
      _vm.$route.path.includes('/jobs') ?
      'router-link-active' :
      '',
    attrs: {
      "href": "/careers",
      "title": "Careers"
    },
    on: {
      "click": function($event) {
        return _vm.openNavigation()
      }
    }
  }, [_vm._v("Careers")])]), _vm._v(" "), _c('li', {
    staticClass: "hide-mobile"
  }, [_c('router-link', {
    staticClass: "btn_orange",
    attrs: {
      "to": "/contact",
      "tag": "button"
    }
  }, [_vm._v("Contact Us")])], 1), _vm._v(" "), _c('li', {
    class: ['hide-desktop', {
      fadeInDown: _vm.navigationToggle
    }]
  }, [_c('a', {
    class: _vm.$route.path.includes('/contact') ? 'router-link-active' : '',
    attrs: {
      "href": "/contact",
      "title": "Contact"
    },
    on: {
      "click": function($event) {
        return _vm.openNavigation()
      }
    }
  }, [_vm._v("Contact Us")])]), _vm._v(" "), _c('li', {
    staticClass: "direct-diversity"
  }, [_c('router-link', {
    attrs: {
      "to": "/agency/diversity"
    }
  }, [_c('img', {
    attrs: {
      "src": "/dist/icn_diversity.jpg",
      "alt": "Diversity"
    }
  })])], 1)])])] : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-704f7b6a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layout/header-component.vue
// module id = 1538
// module chunks = 0